<template>
    <div class="columns full-height has-background-heat-blue-1 reverse-direction-mobile">
        <transition name="slide-lr">
            <div v-if="isLoggedIn" class="column is-one-fifth is-hidden-mobile is-flex">
                <section class="section is-not-super-wide" style="margin-top: auto; margin-bottom: auto; width: 100%;">
                    <nav-panel ref="navPanel"
                               @hook:mounted="()=>{
                                    const children=Array.from($refs.navPanel.$el.children);
                                    children.slice(1).forEach((block)=>{block.classList.add('has-background-white');})
                                }"
                    ></nav-panel>
                </section>
            </div>
        </transition>

        <div class="column has-text-white full-height">
            <section class="section has-text-centered">
                <div class="hero">
                    <div class="hero-body">
                        <h1 class="title is-large has-text-white">{{this.$store.state.siteName}}</h1>
                    </div>
                </div>
                <br>
                <figure class="image half-centered">
                    <img :src="HeatLogo" alt="HEAT Logo">
                </figure>
                <figure v-if="this.$store.state.partnerLogo" class="image half-centered">
                    <br>
                    <img :src="this.$store.state.partnerLogo" class="partner-logo" alt="Partner Logo">
                </figure>
                <br>
                <p>Welcome to the {{this.$store.state.siteName}}.</p>
                <br>
                <a :href="urls.main_site" class="has-text-grey-light">Interested in HEAT or EDAR? Click here to check us out.</a>
            </section>
        </div>

        <transition name="slide-lr">
        <div v-if="!isLoggedIn" class="column has-background-white is-two-fifths is-flex">
            <transition name="slide-lr">
            <section v-if="!Boolean(username)" class="section is-not-super-wide" style="margin-top: auto; margin-bottom: auto; width: 100%">
                <div class="hero has-text-centered">
                    <div class="hero-body">
                        <h1 class="title is-large">Log In</h1>
                    </div>
                </div>
                <login></login>
                <br>
                <a @click="showPasswordReset = true" class="href">Click here if you forgot your password.</a>
                <password-reset-modal :active.sync="showPasswordReset" :resetUrl="urls.password_reset"></password-reset-modal>
            </section>
            </transition>
            <transition name="slide-lr">
                <section v-if="Boolean(username) && !isLoggedIn" class="section is-not-super-wide" style="margin-top: auto; margin-bottom: auto; width: 100%">
                    <div class="hero has-text-centered">
                        <div class="hero-body">
                            <h1 class="title is-large">Enable Two Factor</h1>
                        </div>
                    </div>
                    <b-tabs style="min-height: 35em;">
                        <b-tab-item label="Use an App">
                            <register-totp-app :username="$store.state.user.username" :issuer="siteName">
                            </register-totp-app>
                        </b-tab-item>
                    </b-tabs>
                </section>
            </transition>
        </div>
        </transition>
    </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import urls from "../urls";
    import HeatLogo from "heat-shared/static/HEAT Logo for Box - Transparent.png"
    import Login from "../components/Login";
    import NavPanel from "../components/NavPanel";
    import BTabs from "buefy/src/components/tabs/Tabs";
    import BTabItem from "buefy/src/components/tabs/TabItem";
    import RegisterPhone from "../components/two_factor/RegisterPhone";
    import RegisterTotpApp from "../components/two_factor/RegisterTotpApp";
    import PasswordResetModal from "heat-shared/src/components/PasswordResetModal";

    export default {
        name: "HomePage",
        components: {PasswordResetModal, RegisterTotpApp, RegisterPhone, BTabItem, BTabs, NavPanel, Login},
        mixins: [urls],
        data: () => ({
            'showPasswordReset': false,
        }),
        computed: {
            ...mapGetters('user', [
                'isLoggedIn',
            ]),
            ...mapState('user', [
                'username',
            ]),
            ...mapState([
                'siteName',
            ]),
            HeatLogo: () => HeatLogo,
        },
        methods: {
            log(message){console.log(message)}
        }
    }
</script>

<style scoped>

</style>
